import { getCachedResponse } from "../../cache";
import getDisplayAdPlacement from "../getDisplayAdPlacement";
import getPlacementFromResponse from "../getPlacementFromResponse";

const triggerBeacon = (app, placement, beacon, platform) => {
  const responsePlacement = getDisplayAdPlacement(app, platform, placement);

  const cachedResponse = getCachedResponse();

  const requiredPlacement = getPlacementFromResponse(
    cachedResponse,
    responsePlacement
  );

  if (requiredPlacement[beacon]) {
    navigator.sendBeacon(
      "https://" + requiredPlacement[beacon].replace(/(^\w+:|^)\/\//i, "")
    );
    requiredPlacement[beacon] = null;

    window.gtmDataLayer?.push({
      event: `criteo.display-adverts.${beacon}`,
      app,
      beacon,
      placement,
      lineItemId: requiredPlacement.LineItemID
    });
  } else {
    throw new Error(
      `Beacon: ${beacon} for Placement: ${responsePlacement}, either already fired or no longer exists.`
    );
  }
};

export default triggerBeacon;
